
export class EventConventionExtension {
}
